import PropTypes from "prop-types"
import { SliderButton } from "./SliderButton"
import Text from '../Global/Text'
import { useEffect, useRef, useState } from "preact/hooks"
import AnchorModal from "./AnchorModal";

export const CombinedInsuranceAdditional = ({
    additionalCoverage,
    dispatch,
    userData,
    insuranceName,
    setAddCov,
    values,
    setValues,
    checked
    }) => {

    const sliderButtonEnabled = additionalCoverage.filter((item) => item.type!=='text')
    const initialSlider = sliderButtonEnabled.reduce((acc, item) => {
        acc[item.displayName || item.name] = false
        return acc
    }, {})

    const desc = {};

    const [popup, setPopup] = useState(null);
    const [additionalPopup, setAdditionalPopup] = useState('');
    const [popupClosed, setPopupClosed] = useState(false)

    useEffect(() => {
        if(additionalPopup === '' && popupClosed) {
            setPopup(null)
        }
        setPopupClosed(false)
    },[popupClosed])

    const handlePopUpClick = (itemName) => {
        setPopup(itemName)
    }

  return (
    <div className='additional_coverages_main'>
        {additionalCoverage.map((item) => {
            const itemName = item.value || item.displayName || item.name;
            let packageName = item.package
            let packageDesc;
            if(packageName) {
                desc[itemName] = userData.coverageList[packageName].shortDesc
            }
            else {
                packageDesc = userData.staticQuotes[insuranceName].coveragePrice[0][item.coveragePriceList ? ('coverageCodes'+item.coveragePriceList) : 'coverageCodes'].reduce((acc, pkg) => {
                    acc[userData.coverageList[pkg].name] = userData.coverageList[pkg].recommendDesc !=="" ? userData.coverageList[pkg].recommendDesc
                                                            : userData.coverageList[pkg].longDesc !=="" ? userData.coverageList[pkg].longDesc
                                                                                                        : userData.coverageList[pkg].shortDesc
                    return acc
                }, {})
                desc[itemName] = packageDesc
            }

            return (
                <div key={itemName} className="additional_coverages_content">
                        <div className="additional_coverages_content_coverage_main">
                            <div className="additional_coverages_content_coverage_details">
                                <span className="additional_coverages_content_coverage_details_name">
                                    {itemName}
                                </span>
                                <div className="additional_coverages_popup_icon">
                                    <anchor-icon 
                                        name="help-circle" 
                                        size="small" 
                                        stroke={1.7}
                                        onClick = {() => handlePopUpClick(itemName)}
                                    />
                                </div>
                            </div>
                            {item.coveragePrice && 
                                <span className="additional_coverages_content_coverage_details_price">
                                    +{item.coveragePrice[0]?.packagePrice}
                                    <Text value="$[units.$[paymentFrequency]]" />
                                </span>
                            }
                            {(popup===itemName) && 
                                <AnchorModal 
                                    popup={popup}
                                    setPopup={setPopup}
                                    desc={desc}
                                    additionalPopup={additionalPopup}
                                    setAdditionalPopup={setAdditionalPopup}
                                    setPopupClosed={setPopupClosed}
                                />}
                        </div>
                        {sliderButtonEnabled.includes(item) && 
                            <SliderButton 
                                initialSlider={initialSlider} 
                                dispatch={dispatch} 
                                userData={userData} 
                                item={item} 
                                insuranceName={insuranceName} 
                                setAddCov={setAddCov}
                                values={values}
                                setValues={setValues}
                                checked={checked}
                            />
                        }
                </div>
            )
        })}
    </div>
  )
}
    
CombinedInsuranceAdditional.propTypes = {
    additionalCoverage: PropTypes.array.isRequired,
    dispatch: PropTypes.func.isRequired,
    userData: PropTypes.object.isRequired,
    insuranceName: PropTypes.string.isRequired,
    setAddCov: PropTypes.func.isRequired,
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
    checked: PropTypes.func.isRequired
};
  